module.exports = __webpack_public_path__ + "img/caution.2122ae25.svg";